<jhi-spinner *ngIf="loading"></jhi-spinner>
<div *ngIf="istanzaCorrente">
  <div class="container mt-4">
    <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToHome()">Home</a><span class="separator">/</span></li>
        <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToIstanzeEmesse()">Istanze richieste</a><span class="separator">/</span></li>
        <li class="breadcrumb-item" [ngClass]="{'active': !visualizzaJson}"><a href="javascript:void(0)" (click)="visualizzaJson ? nascondiJsonForm() : ''">Dettaglio istanza</a><span class="separator" *ngIf="visualizzaJson">/</span></li>
        <li class="breadcrumb-item active" *ngIf="visualizzaJson"><a href="javascript:void(0)">Visualizza dati</a></li>
      </ol>
    </nav>
  </div>
  <div [ngClass]="{'d-none': visualizzaJson}">
    <h4 class="text-center my-3 fw-bold">Dettaglio Istanza</h4>
    <div class="row justify-content-center text-center">
      <!-- Card dichiarante -->
      <div class="col-xl-5 col-lg-8 col-md-10 mb-3">
        <div
          class="card card-flex no-after rounded shadow-sm border border-light mb-0 font-philosopher px-3"
          style="justify-content: space-around;">
          <div class="card-image-wrapper with-read-more" *ngIf="istanzaCorrente && istanzaCorrente.istanza && istanzaCorrente.istanza.datiDichiarante">
            <div class="card-body" style="min-height: 510.47px">
              <h3 class="card-title h5" jhiTranslate="riepilogoAppuntamento.datiDichiarante">Dati
                Dichiarante</h3>
              <div class="card border-black border-top">
                <br><br>

                <div class="form-group row">
                  <div class="col-6">
                    <label for="nomeUtente" class="active" jhiTranslate="form.nome">Nome</label>
                    <input disabled readonly id="nomeUtente" class="form-control" type="text"
                           value="{{istanzaCorrente.istanza.datiDichiarante.nome}}">
                  </div>

                  <div class="col-6">
                    <label for="cognomeUtente" class="active" jhiTranslate="form.cognome">Cognome</label>
                    <input disabled readonly id="cognomeUtente" class="form-control" type="text"
                           value="{{istanzaCorrente.istanza.datiDichiarante.cognome}}">
                  </div>
                </div>

                <div *ngIf="istanzaCorrente.istanza.datiDichiarante?.cf" class="form-group">
                  <label for="CFUtente" class="active" jhiTranslate="form.cf">CF</label>
                  <input disabled readonly id="CFUtente" class="form-control" type="text"
                         value="{{istanzaCorrente.istanza.datiDichiarante.cf}}">
                </div>

                <div *ngIf="istanzaCorrente.istanza.datiDichiarante?.email" class="form-group">
                  <label for="emailUtente" class="active" jhiTranslate="form.email">E-mail</label>
                  <input disabled readonly id="emailUtente" class="form-control" type="text"
                         value="{{istanzaCorrente.istanza.datiDichiarante.email}}">
                </div>

                <div *ngIf="istanzaCorrente.istanza.datiDichiarante?.tel" class="form-group">
                  <label for="telefonoUtente" class="active" jhiTranslate="form.numTel">Numero di Telefono</label>
                  <input disabled readonly id="telefonoUtente" class="form-control" type="text"
                         value="{{istanzaCorrente.istanza.datiDichiarante.tel}}">
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Card istanza -->
      <div class="col-xl-5 col-lg-8 col-md-10 mb-3">
        <div
          class="card card-flex no-after rounded shadow-sm border border-light mb-0 font-philosopher px-3"
          style="justify-content: space-around;">
          <div class="card-image-wrapper with-read-more" *ngIf="istanzaCorrente">
            <div class="card-body">
              <h3 class="card-title h5" jhiTranslate="istanze.datiIstanza">Dati Istanza</h3>
              <div class="card border-black border-top">
                <br><br>
                <div class="form-group row mb-0">
                  <div class="col-6">
                    <label for="numeroProtocollo" class="active">Protocollo numero</label>
                    <input disabled readonly id="numeroProtocollo" class="form-control" type="text"
                           value="{{istanzaCorrente.istanza.protocolloNumero}}">
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label for="statoIstanza" class="active">Protocollo anno</label>
                      <input disabled readonly id="statoIstanza" class="form-control" type="text"
                             value="{{istanzaCorrente.istanza.protocolloAnno}}">
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-6">
                    <label for="cdServizio" class="active" jhiTranslate="istanze.codiceServizio">Codice servizio</label>
                    <input disabled readonly id="cdServizio" class="form-control" type="text"
                           value="{{istanzaCorrente.istanza.servizio.cdServizio}}">
                  </div>
                  <div class="col-6">
                    <label for="dlServizio" class="active" jhiTranslate="istanze.stato">Stato</label>
                    <input disabled readonly id="dlServizio" class="form-control" type="text"
                           value="{{istanzaCorrente.istanza.stato.descrizione}}">
                  </div>
                </div>
                <div class="form-group row" *ngIf="istanzaCorrente.istanza.dataMassimaEvasione">
                  <div class="col-12">
                    <label for="dataMassimaEvasione" class="active">Data Massima Evasione</label>
                    <input disabled readonly id="dataMassimaEvasione" class="form-control" type="text"
                           value="{{format(istanzaCorrente.istanza.dataMassimaEvasione)}}">
                  </div>
                </div>

                <div class="form-group mb-0">
                  <label for="descrizioneIstanza" class="active" jhiTranslate="istanze.descrizione">Descrizione</label>
                  <textarea disabled readonly id="descrizioneIstanza"
                            class="form-control border">{{istanzaCorrente.istanza.descrizione || '-'}}</textarea>
                </div>
              </div>
              <!-- Extra Large modal -->
              <button type="button" class="btn btn-primary mt-0" (click)="visualizzaJsonForm()">Visualizza dati</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Storico stati istanza -->
    <div class="row mb-5 pb-5">
      <div class="col-lg-5 offset-1">
        <div class="card card-flex no-after rounded shadow-sm border border-light mb-0 font-philosopher px-3"
             style="padding-bottom: 0">
          <div class="card-image-wrapper with-read-more">
            <div class="card-body">
              <h3 class="card-title h5 text-center" jhiTranslate="istanze.storicoStati">Storico stati</h3>
              <div class="card border-black border-top">
                <div class="table-responsive" style="overflow-x: hidden">
                  <table class="table table-borderless">
                    <caption hidden>Tabella lista stati</caption>
                    <thead>
                    <tr class="border-bottom border-black">
                      <th scope="col" jhiTranslate="istanze.descrizione">Descrizione</th>
                      <th scope="col" jhiTranslate="istanze.dataOra">Data</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let stato of istanzaCorrente.storico; index as i" class="border-bottom">
                      <td class="col-auto">{{ stato.stato.descrizione }}</td>
                      <td>{{ formatDateTs(stato.tsStato).toLocaleString(this.selectedLanguage!.toString(), {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric'
                      })}} - {{formatDateTs(stato.tsStato).toLocaleTimeString(this.selectedLanguage!.toString(), {
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit"
                      })}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Lista allegati dettaglio istanza -->
    <div class="row justify-content-center mb-5 pb-5">
      <div
        *ngIf="istanzaCorrente.integrazioni && istanzaCorrente.integrazioni[0].documenti?.length || istanzaCorrente.documentiOperatore && istanzaCorrente.documentiOperatore.length > 0"
        class="col-lg-10">
        <h4 class="text-center fw-bold" jhiTranslate="istanze.listaAllegati">Lista allegati</h4>
        <div class="card-wrapper d-flex justify-content-center" style="padding-bottom: 0">
          <div class="card card-bg border-bottom-card">
            <div class="card-body">
              <div class="table-responsive" style="overflow-x: hidden">
                <table class="table table-striped">
                  <caption hidden>Tabella lista integrazioni</caption>
                  <thead>
                  <tr class="border-bottom border-black">
                    <th scope="col" jhiTranslate="istanze.nomeFile">Nome File</th>
                    <th scope="col">Descrizione</th>
                    <th scope="col">Caricato da</th>
                    <th scope="col" class="text-center">Data caricamento</th>
                    <th scope="col" class="text-center">Data scadenza</th>
                    <th scope="col" class="text-center">Provenienza</th>
                    <th scope="col" class="text-center">Protocollo numero / anno</th>
                    <th scope="col" class="text-center">Azioni</th>
                  </tr>
                  <tbody>
                  <tr *ngFor="let ist of istanzaCorrente.integrazioni?.[0]?.documenti; index as i"
                      class="border-bottom">
                    <td class="col-auto text-truncate"
                        *ngIf="ist.allegato.titolo !== '-' && ist.allegato.titolo && ist.allegato.titolo !== ''">{{ ist.allegato.titolo }}</td>
                    <td class="col-auto"
                        *ngIf="!ist.allegato.titolo || ist.allegato.titolo === '' || ist.allegato.titolo === '-'">In
                      attesa del file
                    </td>
                    <td *ngIf="ist.allegato.descrizione" class="text-truncate"
                        [title]="ist.allegato.descrizione">{{ ist.allegato.descrizione }}</td>
                    <td *ngIf="!ist.allegato.descrizione">-</td>
                    <td *ngIf="ist.createdByDescr">{{ ist.createdByDescr }}</td>
                    <td *ngIf="!ist.createdByDescr">-</td>
                    <td *ngIf="ist.tsCaricamento" class="text-center">{{formatDateNormal(ist.tsCaricamento)}}</td>
                    <td *ngIf="!ist.tsCaricamento" class="text-center">In attesa del file</td>
                    <td *ngIf="ist.dataScadenza" class="text-center">{{formatDateNormal(ist.dataScadenza)}}</td>
                    <td *ngIf="!ist.dataScadenza" class="text-center">-</td>
                    <td class="text-center" *ngIf="ist.provenienza">{{mapRuoli.get(ist.provenienza)}}</td>
                    <td class="text-center" *ngIf="!ist.provenienza">-</td>
                    <td class="text-center"><span *ngIf="ist.protocolloNumero">{{ist.protocolloNumero}}</span><span *ngIf="ist.protocolloAnno"> / {{ist.protocolloAnno}}</span><span *ngIf="!ist.protocolloNumero && !ist.protocolloAnno">-</span></td>
                    <td class="position-relative"
                        *ngIf="ist.allegato.titolo !== '-' && ist.allegato.titolo && ist.allegato.titolo !== ''">
                      <button class="button c-pointer primary-button centered"
                              (click)="downloadIntegrazione(ist.allegato.contenuto, ist.allegato.titolo)">
                        <div class="button-wrapper position-relative">
                          <div class="text fw-bold" jhiTranslate="certificazioniEmesseTableTh.scarica">Scarica</div>
                          <span class="icon-download">
                              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="10px"
                                   height="10px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17"></path>
                              </svg>
                            </span>
                        </div>
                      </button>
                    </td>
                    <td class="position-relative"
                        *ngIf="!ist.allegato.titolo || ist.allegato.titolo === '' || ist.allegato.titolo === '-'">
                      <button class="button c-pointer primary-button centered"
                              (click)="getIntegrazione(istanzaCorrente.istanza.id)"
                              [disabled]="istanzaCorrente.istanza.stato.codice === '06'"
                              [ngClass]="{'disabled-carica': istanzaCorrente.istanza.stato.codice === '06'}">
                        <div class="button-wrapper position-relative" (mouseenter)="checkTooltip()"
                             (mouseleave)="hideTooltip()">
                          <div class="text fw-bold" jhiTranslate="certificazioniEmesseTableTh.carica">Carica</div>
                          <span class="icon-download">
                              <svg class="icon icon-sm icon-white">
                                <use href="./content/svg/sprites.svg#it-upload"></use>
                              </svg>
                            </span>
                        </div>
                      </button>
                    </td>
                    <!-- <span *ngIf="showTooltip" class="fw-bold">L'istanza è in attesa</span> -->
                  </tr>
                  <tr *ngFor="let ist of istanzaCorrente.documentiOperatore; index as i" class="border-bottom">
                    <td class="col-auto text-truncate" [title]="ist.allegato.titolo"
                        *ngIf="ist.allegato.titolo !== '-' && ist.allegato.titolo && ist.allegato.titolo !== ''">{{ ist.allegato.titolo }}</td>
                    <td class="col-auto text-truncate"
                        *ngIf="!ist.allegato.titolo || ist.allegato.titolo === '' || ist.allegato.titolo === '-'">In
                      attesa del file
                    </td>
                    <td *ngIf="ist.allegato.descrizione"
                        [title]="ist.allegato.descrizione">{{ ist.allegato.descrizione }}</td>
                    <td *ngIf="!ist.allegato.descrizione">-</td>
                    <td
                      *ngIf="ist.createdByDescr">{{ ist.createdByDescr }}
                    <td *ngIf="!ist.createdByDescr">-</td>
                    <td *ngIf="ist.tsCaricamento" class="text-center">{{formatDateNormal(ist.tsCaricamento)}}</td>
                    <td *ngIf="!ist.tsCaricamento" class="text-center">In attesa del file</td>
                    <td *ngIf="ist.dataScadenza" class="text-center">{{formatDateNormal(ist.dataScadenza)}}</td>
                    <td *ngIf="!ist.dataScadenza" class="text-center">-</td>
                    <td class="text-center" *ngIf="ist.provenienza">{{mapRuoli.get(ist.provenienza)}}</td>
                    <td class="text-center" *ngIf="!ist.provenienza">-</td>
                    <td class="text-center"><span *ngIf="ist.protocolloNumero">{{ist.protocolloNumero}}</span><span *ngIf="ist.protocolloAnno"> / {{ist.protocolloAnno}}</span><span *ngIf="!ist.protocolloNumero && !ist.protocolloAnno">-</span></td>
                    <td class="position-relative">
                      <button class="button c-pointer centered"
                              (click)="downloadIntegrazione(ist.allegato.contenuto, ist.allegato.titolo)">
                        <div class="button-wrapper position-relative">
                          <div class="text fw-bold" jhiTranslate="certificazioniEmesseTableTh.scarica">Scarica</div>
                          <span class="icon-download">
                              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="10px"
                                   height="10px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17"></path>
                              </svg>
                            </span>
                        </div>
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Lista pagamenti dettaglio istanza -->
    <div class="row justify-content-center mb-5 pb-5">
      <div *ngIf="istanzaCorrente.integrazioni && istanzaCorrente.integrazioni[0]?.pagamenti?.length" class="col-lg-10">
        <h4 class="text-center fw-bold" jhiTranslate="istanze.listaPagamenti">Lista pagamenti</h4>
        <div class="card-wrapper d-flex justify-content-center" style="padding-bottom: 0">
          <div class="card card-bg border-bottom-card">
            <div class="card-body">
              <div class="table-responsive" style="overflow-x: hidden">
                <table class="table table-striped">
                  <caption hidden>Tabella lista pagamenti</caption>
                  <thead>
                  <tr>
                    <th scope="col" class="text-center">ID</th>
                    <th scope="col" class="text-center">Importo</th>
                    <th scope="col" class="text-center">Stato</th>
                    <th scope="col" class="text-center">Data del pagamento</th>
                    <th scope="col" class="text-center">Data scadenza</th>
                    <th scope="col" class="text-center">Azioni</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let pg of istanzaCorrente.integrazioni[0].pagamenti; index as i">
                    <td class="text-center">{{ pg.id}}</td>
                    <td class="text-center">{{ pg.importo | currency: 'EUR'}}</td>
                    <td class="text-center">{{ mapStatiPagamento.get(pg.stato)?.testo }}</td>
                    <td class="text-center"
                        *ngIf="pg.dataPagamento">{{formatDate(pg.dataPagamento).toLocaleString(this.selectedLanguage!.toString(), {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric'
                    })}}</td>
                    <td class="text-center" *ngIf="!pg.dataPagamento">In attesa del pagamento</td>
                    <td *ngIf="pg.dataScadenza" class="text-center">{{formatDateNormal(pg.dataScadenza)}}</td>
                    <td *ngIf="!pg.dataScadenza" class="text-center ">-</td>
                    <td *ngIf="pg.stato === '00'" class="position-relative">
                      <div class="d-flex justify-content-around">
                        <button class="button c-pointer primary-button"
                                (click)="goToPagamento(istanzaCorrente.istanza, pg.id)">
                          <div class="button-wrapper position-relative">
                            <div class="text fw-bold" jhiTranslate="pagamenti.paga">Paga</div>
                            <span class="icon-download">
                              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-primary grow" id="Icons"
                                   viewBox="0 0 32 32">
                          <style type="text/css">
                            .st0 {
                              fill: none;
                              stroke: white;
                              stroke-width: 2;
                              stroke-linecap: round;
                              stroke-linejoin: round;
                              stroke-miterlimit: 10;
                            }

                            .st3 {
                              fill: none;
                            }
                          </style>
                          <path class="st0"
                                d="M19.7,26.8c-0.9-0.9-1.1-2.2-0.7-3.3l-3.3-3.3c-1.6-1.6-1.5-4.4,0.3-6.2l0,0l5,5"/>
                          <path class="st0" d="M12.7,26.3c0.6,0.7,1.3,1.3,2.1,1.7c0.7,0.4,1.2,1.2,1.2,2v0"/>
                          <path class="st0" d="M18,24H8c-1.1,0-2-0.9-2-2V5c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v13"/>
                          <line class="st0" x1="10" y1="3" x2="10" y2="24"/>
                          <line class="st0" x1="16" y1="6" x2="16" y2="10"/>
                          <path class="st0" d="M25,30v-9.5c0-3.3-2-6.2-5-7.4"/>
                          <rect x="-144" y="-216" class="st3" width="536" height="680"/>
                        </svg>
                            </span>
                          </div>
                        </button>
                        <button class="button primary-button fw-bold ms-2" style="width: 200px" type="button"
                                *ngIf="pg.avvisoPagopa"
                                (click)="scaricaAvviso(pg.avvisoPagopa)">
                          <div class="button-wrapper position-relative">
                            <div class="text fw-bold">Scarica avviso</div>
                            <span class="icon-download">
                                                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                                                                 role="img" width="10px"
                                                                 height="10px" preserveAspectRatio="xMidYMid meet"
                                                                 viewBox="0 0 24 24">
                                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17"></path>
                          <style type="text/css">
                            .st0 {
                              fill: none;
                              stroke: white;
                              stroke-width: 2;
                              stroke-linecap: round;
                              stroke-linejoin: round;
                              stroke-miterlimit: 10;
                            }

                            .st3 {
                              fill: none;
                            }
                          </style>
                        </svg>
                            </span>
                          </div>
                        </button>
                      </div>
                    </td>
                    <td class="fw-bold text-center" *ngIf="pg.stato === '01'">
                      Pagato
                    </td>
                    <td class="fw-bold text-center" *ngIf="pg.stato === '10'">
                      Annullato
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="modal fade" id="modaleJson" tabindex="-1" role="dialog" aria-labelledby="myExtraLargeModalLabel"
       aria-hidden="true">
    <div class="modal-dialog modal-fullscreen" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title h5 " id="myExtraLargeModalLabel">Modale molto grande</h2>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Chiudi finestra modale"></button>
        </div>
        <div class="modal-body">
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid" [ngClass]="{'d-none': !visualizzaJson}">
  <div class="d-flex">

  </div>
  <div class="container border mt-1 mb-5">
    <div class="d-flex justify-content-end mt-2">
      <svg class="icon icon-danger c-pointer" title="Chiudi visualizzazione dati" (click)="nascondiJsonForm()"><use href="content/svg/sprites.svg#it-close-circle"></use></svg>
    </div>
    <div class="mb-2">
      <div class="mb-4">
        <h3 class="text-center fw-bold my-4">{{istanzaCorrente?.istanza?.descrizione}}</h3>
        <h5 class="fw-bold" jhiTranslate="istanze.nuovo.dati">Dati istanza:</h5>
        <div class="row">
          <div class="col-3"><span class="fw-bold"
                                   jhiTranslate="istanze.nuovo.nome">Nome:</span> {{istanzaCorrente?.istanza?.datiDichiarante?.nome}}
          </div>
          <div class="col-3">
            <span class="fw-bold"
                  jhiTranslate="istanze.nuovo.cognome">Cognome:</span> {{istanzaCorrente?.istanza?.datiDichiarante?.cognome}}
          </div>
          <div class="col-3">
          <span class="fw-bold"
                jhiTranslate="istanze.nuovo.data">Data:</span> {{formatDate(istanzaCorrente?.istanza?.dtIstanza).toLocaleString(this.selectedLanguage!.toString(), {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          })}}
          </div>
          <div class="col-3" *ngIf="istanzaCorrente">
            <span class="fw-bold" *ngIf="istanzaCorrente">Stato:</span> {{istanzaCorrente.istanza.stato.descrizione}}
          </div>
        </div>
      </div>
      <dmidynamic-form-render [nascondiStepper]="true"></dmidynamic-form-render>
    </div>
  </div>
</div>
